import React from "react";
import { portfolioData } from "../data/portfolioData";
import {
  SiGithub,
  SiGoogleanalytics,
  SiKeras,
  SiLinkedin,
  SiNumpy,
  SiPandas,
  SiPython,
  SiScikitlearn,
  SiSqlite,
  SiTableau,
  SiTensorflow,
} from "react-icons/si";

const techIcons = [
  { label: "Python", icon: SiPython },
  { label: "SQL", icon: SiSqlite },
  { label: "Power BI", icon: SiTableau },
  { label: "Pandas", icon: SiPandas },
  { label: "NumPy", icon: SiNumpy },
  { label: "Scikit-learn", icon: SiScikitlearn },
  { label: "TensorFlow", icon: SiTensorflow },
  { label: "Keras", icon: SiKeras },
  { label: "Data Analysis", icon: SiGoogleanalytics },
];

const Hero = () => {
  const { name, role, about, location, email, hero, github, linkedin, profileImage } = portfolioData;
  const topTools = portfolioData.toolsAndTechnologies
    .flatMap((group) => group.items)
    .slice(0, 5);

  const onResumeClick = () => {
    const key = "resume_download_count";
    const prev = Number(window.localStorage.getItem(key) || "0");
    window.localStorage.setItem(key, String(prev + 1));
  };

  return (
    <section id="hero" className="scroll-mt-24 border-b border-slate-200 bg-white/85 py-16 md:py-20">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 md:px-6 lg:grid-cols-[1.25fr_0.75fr]">
        <div>
          <div className="mb-5 inline-flex items-center gap-4 rounded-full border border-slate-200 bg-white px-3 py-2 shadow-sm">
            <div className="h-14 w-14 overflow-hidden rounded-full border border-slate-200 bg-slate-100">
              <img
                src={profileImage}
                alt={name}
                className="h-full w-full object-cover"
                onError={(event) => {
                  event.currentTarget.style.display = "none";
                }}
              />
            </div>
            <div>
              <p className="text-sm font-semibold text-slate-900">{name}</p>
              <p className="text-xs text-slate-600">{role}</p>
            </div>
          </div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-indigo-700">
            {hero.tagline}
          </p>
          <h1 className="mt-4 text-4xl font-bold leading-tight text-slate-900 md:text-6xl">
            {name}
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-700 md:text-lg">
            {about}
          </p>
          <div className="mt-6 flex flex-wrap gap-3 text-sm text-slate-700">
            <span className="rounded-full border border-slate-300 bg-white px-3 py-1">
              {hero.locationIcon} {location}
            </span>
            <span className="rounded-full border border-slate-300 bg-white px-3 py-1">{email}</span>
          </div>
          <div className="mt-8 flex flex-wrap gap-4">
            <a
              href="/Sushmita_Pal_Data_Analyst_Resume.pdf"
              target="_blank"
              rel="noreferrer"
              download="Sushmita_Pal_Data_Analyst_Resume.pdf"
              onClick={onResumeClick}
              className="rounded-full bg-indigo-600 px-6 py-3 text-sm font-semibold text-white transition hover:bg-indigo-500"
            >
              {hero.resumeLabel}
            </a>
            <a
              href="#contact"
              className="rounded-full border border-slate-300 px-6 py-3 text-sm font-semibold text-slate-900 transition hover:border-indigo-600 hover:text-indigo-700"
            >
              {hero.contactLabel}
            </a>
            <a
              href={github}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-slate-300 px-5 py-3 text-sm font-semibold text-slate-900 transition hover:border-indigo-600 hover:text-indigo-700"
            >
              <SiGithub />
              {hero.githubLabel}
            </a>
            <a
              href={linkedin}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-slate-300 px-5 py-3 text-sm font-semibold text-slate-900 transition hover:border-indigo-600 hover:text-indigo-700"
            >
              <SiLinkedin />
              {hero.linkedinLabel}
            </a>
          </div>
        </div>

        <aside className="rounded-2xl border border-slate-200 bg-white/80 p-6 backdrop-blur">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-indigo-700">
            {hero.snapshotTitle}
          </p>
          <ul className="mt-4 space-y-3 text-sm text-slate-700">
            <li>
              <span className="font-semibold text-slate-600">{hero.snapshotRoleLabel}</span> {role}
            </li>
            <li>
              <span className="font-semibold text-slate-600">{hero.snapshotLocationLabel}</span>{" "}
              {location}
            </li>
            <li>
              <span className="font-semibold text-slate-600">{hero.snapshotStackLabel}</span>{" "}
              {topTools.join(", ")}
            </li>
          </ul>
          <div className="mt-6 grid grid-cols-3 gap-3">
            {techIcons.slice(0, 6).map((item, index) => {
              const Icon = item.icon;
              return (
                <div
                  key={`${item.label}-${index}`}
                  className="flex flex-col items-center rounded-xl border border-slate-200 bg-white px-2 py-3 text-center text-xs text-slate-700"
                >
                  <Icon className="mb-1 text-base text-indigo-700" />
                  {item.label}
                </div>
              );
            })}
          </div>
        </aside>
      </div>
    </section>
  );
};

export default Hero;
